import { z } from 'zod'
import type { AppLinkQrToken } from '../../models/AppLinkQrToken'
import { BaseAppDTO, mapBaseAppToDTO, mapDTOToBaseApp } from './BaseAppDTO'
import { createInstantSafe } from '~/shared/composables/useTemporal'

export const AppLinkQrTokenDTOSchema = z.object({
  qr_token: z.string().uuid(),
  expires_at: z.string(),
  app: BaseAppDTO.optional()
})

export type AppLinkQrTokenDTO = z.infer<typeof AppLinkQrTokenDTOSchema>

export function mapDTOToAppLinkQrToken (dto: AppLinkQrTokenDTO): AppLinkQrToken {
  return {
    qrToken: dto.qr_token,
    expiresAt: createInstantSafe(dto.expires_at)!,
    app: dto.app != null ? mapDTOToBaseApp(dto.app) : undefined
  }
}

export function mapAppLinkQrTokenToDTO (model: AppLinkQrToken): AppLinkQrTokenDTO {
  return {
    qr_token: model.qrToken,
    expires_at: model.expiresAt.toString(),
    app: model.app != null ? mapBaseAppToDTO(model.app) : undefined
  }
}
